import { type ClassValue, clsx } from 'clsx';

/** Joins class names. No Tailwind merge: prototype classes are not utilities. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
